import PropTypes from 'prop-types';

export default {
  color: PropTypes.oneOf(['primary', 'secondary', 'default', 'inherit'])
    .isRequired,
  isPrimary: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.node,
  anchor: PropTypes.oneOf(['left', 'right']),
};
